module.exports = __webpack_public_path__ + "assets/img/slogan-6c88f416.png";